import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as Icon } from '../Icon/Icon-Cgh13Jz2.js';
import { c as check, a as exclamation, e as exclamationTriangle, i as infoCircle, J as cog, r as rocketSolid } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const getIconType = variant => {
  switch (variant) {
    case 'new':
      return rocketSolid;
    case 'beta':
      return cog;
    case 'info':
      return infoCircle;
    case 'warning':
      return exclamationTriangle;
    case 'error':
      return exclamation;
    case 'success':
      return check;
    default:
      return undefined;
  }
};
const TagIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40025937__sc-osvndd-0"
})(["align-self:center;"]);
const TagWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40025937__sc-osvndd-1"
})(["min-height:", ";"], ({
  theme
}) => theme.controls.height.xsmall.default);
const TagComponent = ({
  className,
  label,
  variant = 'default',
  withIcon = false,
  icon,
  description,
  ...rest
}) => {
  var _getIconType;
  const iconType = (_getIconType = getIconType(variant)) !== null && _getIconType !== void 0 ? _getIconType : icon;
  return /*#__PURE__*/React__default.createElement(TagWrapper, _extends({
    className: className,
    "aria-label": description
  }, rest), withIcon && iconType && /*#__PURE__*/React__default.createElement(TagIcon, {
    type: iconType
  }), !!label && /*#__PURE__*/React__default.createElement("span", null, label));
};
const Tag = /*#__PURE__*/styled(TagComponent).withConfig({
  componentId: "sc-storm-ui-40025937__sc-osvndd-2"
})(["font:", ";color:", ";display:inline-flex;flex-wrap:nowrap;text-wrap:nowrap;align-items:baseline;gap:", ";background:", ";padding-inline:", ";padding-block:", ";border-radius:", ";", ""], ({
  theme
}) => theme.font.text.xsmall.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.spacing.xxxsmall.default, ({
  theme,
  variant
}) => {
  switch (variant) {
    case 'beta':
      return theme.tag.backgroundColor.beta;
    case 'new':
      return theme.tag.backgroundColor.new;
    case 'info':
      return theme.tag.backgroundColor.info;
    case 'warning':
      return theme.tag.backgroundColor.warning;
    case 'error':
      return theme.tag.backgroundColor.error;
    case 'success':
      return theme.tag.backgroundColor.success;
    case 'violet':
      return theme.tag.backgroundColor.violet;
    case 'cyan':
      return theme.tag.backgroundColor.cyan;
    case 'magenta':
      return theme.tag.backgroundColor.magenta;
    case 'periwinkle':
      return theme.tag.backgroundColor.periwinkle;
    case 'redOrange':
      return theme.tag.backgroundColor.redOrange;
    case 'chartreuse':
      return theme.tag.backgroundColor.chartreuse;
    default:
      return theme.tag.backgroundColor.default;
  }
}, ({
  theme
}) => theme.controls.paddingInline.medium.default, ({
  theme
}) => theme.controls.paddingBlock.xsmall.default, ({
  theme
}) => theme.border.radius.large, isMobile(css(["font:", ";gap:", ";padding-inline:", ";padding-block:", ";"], ({
  theme
}) => theme.font.text.xsmall.mobile, ({
  theme
}) => theme.spacing.xxxsmall.mobile, ({
  theme
}) => theme.controls.paddingInline.medium.mobile, ({
  theme
}) => theme.controls.paddingBlock.xsmall.mobile)));

export { Tag as T };
//# sourceMappingURL=Tag-Cta81iyH.js.map
